export const GET_ALL_SCHEDULE_TIMING_LIST = "GET_ALL_SCHEDULE_TIMING_LIST";
export const GET_ALL_SCHEDULE_TIMING_LIST_FAIL = "GET_ALL_SCHEDULE_TIMING_LIST_FAIL";
export const GET_ALL_SCHEDULE_TIMING_LIST_SUCCESS = "GET_ALL_SCHEDULE_TIMING_LIST_SUCCESS";
export const GET_ALL_SCHEDULE_TIMING_LIST_RESET = "GET_ALL_SCHEDULE_TIMING_LIST_RESET";

//getAppointmentList
export const getAllScheduleTimingList = (params) => {
  return { type: GET_ALL_SCHEDULE_TIMING_LIST, params };
};
export const getAllScheduleTimingListFail = (response) => {
  return { type: GET_ALL_SCHEDULE_TIMING_LIST_FAIL, response };
};
export const getAllScheduleTimingListSuccess = (response) => {
  return { type: GET_ALL_SCHEDULE_TIMING_LIST_SUCCESS, response };
};
export const getAllScheduleTimingListReset = () => {
  return { type: GET_ALL_SCHEDULE_TIMING_LIST_RESET };
};
